import React, {useState, useEffect} from 'react'
import clpLogo from "../../resources/ClassplusLogo.png";
import "./detailsPage.css"
import { Button,Form,Input  } from 'semantic-ui-react'

import {  female, male, maleAppView, femaleAppView  } from '../../utils/tecahersCard';

const DetailsPage = (props) => {

  let { type, className } = props.location.state;
  
 
  const [studentName, setStudentName] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [teachersName, setTeacherName] = useState('')
  const [friendName, setFriendName] = useState('')
  const [isDisabled, setisDisabled] = useState(true)

  const [ isToken, setisToken ] = useState(false)

  const [teacherIdFromAPI, setteacherIdFromAPI] = useState()

  

  const handlePostApi = async ()=>{
    let body ={
      studentName: studentName,
      studentNumber: mobileNumber,
      teacherName: teachersName,
      creativeId: props.location.state.imageKey,
      teacherId: ""
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    };
    await fetch('https://multiverse-api.classplusapp.com/ts/teachersday/add-teacher', requestOptions)
    .then(response => response.json()).then(response => setteacherIdFromAPI(response.data.teacherId))     
  }
  

    const handleSubmitClick = (imageKey) => {
      // handlePostApi()

        props.history.push({
            pathname: '/output', 
            state: { imageKey, studentName, teachersName, mobileNumber , friendName, type, className }
          })
    }

    useEffect(() => {
        if(mobileNumber.length > 10) {
          setMobileNumber(mobileNumber.slice(0,10))
        }
        if(studentName && mobileNumber && teachersName &&  mobileNumber.length >9){
          setisDisabled(false)
        }

    },[studentName, mobileNumber, teachersName])

    useEffect(() => {
        if(sessionStorage.getItem("token")){
          setisToken(true)
        }
    }, [])

console.log(isToken, "istoken")
    return (
      <div id="details-page">
        <div id="navbar">
          <img src={clpLogo} id="navbar-clpLogo" />
        </div>
        <div id="card-display">
          {props.location.state ? (
            type === "male" ?  
            <img src={ isToken ? maleAppView[props.location.state.imageKey].firstImg : male[props.location.state.imageKey].firstImg} /> :
            type === "female" ?
            <img src={ isToken ? femaleAppView[props.location.state.imageKey].firstImg :  female[props.location.state.imageKey].firstImg} /> :
            ""
          ) : (
            ""
          )}
        </div>

        <div id="enter-details">
          <div id="personalise-this-memory">
          Create your own #ClassWaliDosti post
          </div>
          {/* <Form style={{textAlign: "left" , marginTop:"8%"}}> */}
          <span id="inputText">Your Name</span>
          <Input
            maxLength = "15"
            value={studentName}
            style={{ width: "100%", marginTop: "2%" , fontSize: "14px"}}
            placeholder="Enter your Name"
            onChange={(e)=>{setStudentName(e.target.value)}}
          />

          <span id="inputText">Your Friend’s Name</span>
          <Input
            maxLength ="15"
            type="string"
            value={friendName}
            style={{ width: "100%", marginTop: "2%" , fontSize: "14px" }}
            placeholder="Enter your friends name"
            onChange={(e)=>{setFriendName(e.target.value)}}
          />


          <span id="inputText">Your Mobile Number</span>
          <Input
            type="number"
            value={mobileNumber}
            style={{ width: "100%", marginTop: "2%" , fontSize: "14px" }}
            placeholder="e.g - 9560393759"
            onChange={(e)=>{setMobileNumber(e.target.value)}}
          />


          <span id="inputText">
            In which teacher's class did you create this memory?
          </span>
          <Input
            maxLength = "15"
            value={teachersName}
            style={{ width: "100%", marginTop: "2%" , fontSize: "14px" }}
            placeholder={
              type == "male" ?
              "Enter your sir’s name" :
              type =="female" ?
              "Enter your ma'am’s name" :
              ""
            }
            onChange={(e)=>{setTeacherName(e.target.value)}}
          ></Input>
          {/* </Form>   */}
        </div>
        <div id="details-bottom-div">
          <button  
          disabled={isDisabled}
          onClick={()=>handleSubmitClick(props.location.state.imageKey)}
          id="details-submit-cta">Create & Preview</button>
        </div>
      </div>
    );
}

export default DetailsPage
